import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationComponent } from 'src/app/shared/components/notification/notification.component';
import { ClientData } from './cliet.data';
import { EmployeeService } from 'src/app/shared/services/employe.service';
import { Observable } from 'rxjs';
import * as moment from 'moment';

@Component({
  selector: 'app-client-profile',
  templateUrl: './client-profile.component.html',
  styleUrls: ['./client-profile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientProfileComponent implements OnInit {
  clientProfile: FormGroup = this.fb.group({
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    email: ['@gmail.com', [Validators.required, Validators.email]],
    phoneNumber: [null, [Validators.required, Validators.maxLength(12)]],
    clientType: ['Domestic', Validators.required],
    package: [{ value: '6 Months', disabled: false }],
    packageStartDate: [{ value: new Date(), disabled: false }],
    packageEndDate: [{ value: new Date(), disabled: false }],
    amntReceivedDate: [{ value: new Date(), disabled: false }],
    packageAmnt: [{ value: '16999', disabled: false }],
    amntRemainingDate: [{ value: new Date(), disabled: false }],
    amntRemaining: [{ value: '0', disabled: false }],
    amntReceived: [{ value: '0', disabled: false }],
    roleId: ['client'],
    status: ['New'],
    updateDate: [new Date()],
    creareDate: [new Date()],
    appointmentNo: [0],
    assignDietician: ['', [Validators.required]],
    assignCoDietician: ['', []],
    clientTimezone: [],
  });
  timezones = this.getFormattedTimezones(moment.tz.names()); // Get list of timezones from moment-timezone
  filteredTZ = this.getFormattedTimezones(moment.tz.names());
  submitIcon = '../../../assets/images/submit (5).png';
  packageAmount = ClientData.PACKAGE_AMOUNT;
  selectedPackage: any = this.packageAmount[0];
  dietPackages = ClientData.PACKAGES;
  clientTypes = ClientData.CLIENT_TYPES;
  userUID: any;
  isLoading: boolean = false;
  employee$: Observable<any> | undefined;
  constructor(
    private fb: FormBuilder,
    private firestore: AngularFirestore,
    private auth: AngularFireAuth,
    private snackbar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
    private empService: EmployeeService
  ) {
    this.userUID = this.route.snapshot.params['id'];
    this.setPackageEndDate('6 Months');
    this.coDieticianValidator();
  }

  coDieticianValidator() {
    this.clientProfile
      .get('assignDietician')
      ?.valueChanges.subscribe((value) => {
        const assignCoDieticianControl =
          this.clientProfile.get('assignCoDietician');
        if (value === 'Aasiya Ali') {
          assignCoDieticianControl?.setValidators([Validators.required]);
        } else {
          assignCoDieticianControl?.clearValidators();
        }
        assignCoDieticianControl?.updateValueAndValidity();
      });
  }

  getFormattedTimezones(timezones: string[]): string[] {
    return timezones.map((tz) => {
      const city = tz.split('/')[1]?.replace('_', ' ') || tz; // Extract city name
      const abbreviation = moment.tz(tz).zoneAbbr(); // Get timezone abbreviation (e.g., IST, BST)
      const offset = moment.tz(tz).utcOffset() / 60; // Get UTC offset in hours
      const offsetString = offset >= 0 ? `+${offset}` : `${offset}`; // Format offset as +X or -X
      return `${tz} (${city}, ${abbreviation}, GMT${offsetString})`; // Combine all details
    });
  }

  ngOnInit(): void {
    this.employee$ = this.empService.getEmployeeData();
    if (this.userUID) {
      this.firestore
        .collection('clientProfile')
        .doc(this.userUID)
        .get()
        .subscribe((data: any) => {
          if (data.data()) {
            this.clientProfile.patchValue(data.data());
            setTimeout(() => {
              this.transformDate();
            }, 50);
          }
        });
    }

    this.clientProfile.controls['clientType'].valueChanges.subscribe((data) => {
      this.selectedPackage = this.packageAmount.find((x: any) => x.id === data);
      setTimeout(() => {
        const amnt = this.selectedPackage.value.find(
          (x: any) => x.id === this.clientProfile.controls['package'].value
        );
        this.clientProfile.controls['packageAmnt'].setValue(amnt.value);
      }, 50);
    });

    this.clientProfile.controls['package'].valueChanges.subscribe((data) => {
      const amnt = this.selectedPackage.value.find((x: any) => x.id === data);
      this.clientProfile.controls['packageAmnt'].setValue(amnt.value);
      this.setPackageEndDate(data);
    });
    this.clientProfile.controls['amntReceived'].valueChanges.subscribe(
      (data) => {
        const amnt = this.clientProfile.controls['packageAmnt'].value - data;
        this.clientProfile.controls['amntRemaining'].setValue(amnt);
      }
    );
    this.clientProfile.controls['packageAmnt'].valueChanges.subscribe(
      (data) => {
        const amnt = data - this.clientProfile.controls['amntReceived'].value;
        this.clientProfile.controls['amntRemaining'].setValue(amnt);
      }
    );
    this.clientProfile.controls['packageStartDate'].valueChanges.subscribe(
      (data) => {
        this.setPackageEndDate(data);
      }
    );
  }

  transformDate() {
    this.clientProfile.controls['amntReceivedDate'].setValue(
      new Date(this.clientProfile.controls['amntReceivedDate'].value.toDate())
    );
    this.clientProfile.controls['amntRemainingDate'].setValue(
      new Date(this.clientProfile.controls['amntRemainingDate'].value.toDate())
    );
    this.clientProfile.controls['packageStartDate'].setValue(
      new Date(this.clientProfile.controls['packageStartDate'].value.toDate())
    );
    this.clientProfile.controls['packageEndDate'].setValue(
      new Date(this.clientProfile.controls['packageEndDate'].value.toDate())
    );
  }

  setPackageEndDate(val: string | Date) {
    let months: number = 0;
    const d = new Date();
    if (typeof val === 'object') {
      months = Number(this.clientProfile.controls['package'].value.charAt(0));
      d.setMonth(val.getMonth() + months);
      d.setDate(val.getDate() - 1);
    } else {
      this.clientProfile.controls['packageStartDate'].setValue(new Date());
      months = Number(val.charAt(0));
      d.setMonth(d.getMonth() + months);
      d.setDate(d.getDate() - 1);
    }
    this.clientProfile.controls['packageEndDate'].setValue(d);
  }

  onSubmit() {
    if (this.clientProfile.invalid) return;

    if (this.userUID) {
      this.updateUser();
    } else {
      this.createUser();
    }
  }

  updateUser() {
    this.isLoading = true;
    this.clientProfile.controls['updateDate'].setValue(new Date());
    this.firestore
      .collection('clientProfile')
      .doc(this.userUID)
      .set(this.clientProfile.getRawValue())
      .then((data) => {
        this.snackbar.openFromComponent(NotificationComponent, {
          data: {
            customMsg: `User Profile Updated Successfully.`,
            type: 'success',
          },
        });
        this.isLoading = false;
        this.router.navigate(['./layout/create-diet-plan/']);
      })
      .catch((error) => {
        this.snackbar.openFromComponent(NotificationComponent, {
          data: {
            customMsg: error.message,
            type: 'error',
          },
        });
        this.isLoading = false;
      });
  }

  createUser() {
    this.isLoading = true;
    const emailId = this.clientProfile.controls['email'].value;
    const password = this.clientProfile.controls['phoneNumber'].value;
    this.auth
      .createUserWithEmailAndPassword(emailId, password)
      .then((data: any) => {
        this.userUID = data?.user?.uid;
        this.createClientProfile();
      })
      .catch((error) => {
        this.snackbar.openFromComponent(NotificationComponent, {
          data: {
            customMsg: error.message,
            type: 'error',
          },
        });
        this.isLoading = false;
      });
  }

  createClientProfile() {
    this.firestore
      .collection('clientProfile')
      .doc(this.userUID)
      .set(this.clientProfile.getRawValue())
      .then((data) => {
        this.snackbar.openFromComponent(NotificationComponent, {
          data: {
            customMsg: 'Student account created successfully.',
            type: 'success',
          },
        });
        this.isLoading = false;
        this.sendEmailConfirmation();
        this.clearInputMethod();
      })
      .catch((error) => {
        this.snackbar.openFromComponent(NotificationComponent, {
          data: {
            customMsg: error.message,
            type: 'error',
          },
        });
        this.isLoading = false;
      });
  }

  sendEmailConfirmation() {
    this.auth.currentUser
      .then((user) => user?.sendEmailVerification())
      .then((data) => {
        console.log(data);
      });
  }

  clearInputMethod() {
    this.clientProfile.reset();
    this.selectedPackage = this.packageAmount[0];
  }

  onFilter(e: any) {
    const val = e?.target?.value;
    setTimeout(() => {
      this.filteredTZ = this.timezones.filter((item) =>
        item.toLocaleLowerCase().includes(val.toLocaleLowerCase())
      );
      // this.filteredTZ = this.getFormattedTimezones(this.timezones);
    }, 50);
  }
}
